import React from 'react'
import { Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Outlet } from 'react-router-dom';
import { BellRing, Briefcase, Users, Award, UserPen, CalendarPlus, ClipboardList, Book, Image, LayoutDashboard, Newspaper, UserPlus, FileText, GraduationCap, } from 'lucide-react';

const AdminLayout = () => {

    const navItems = [
        { icon: LayoutDashboard, label: "Dashboard", path: '/admin' },
        { icon: BellRing, label: 'Notifications', path: '/admin/notifications' },
        { icon: Newspaper, label: 'News Events', path: '/admin/news-events' },
        { icon: UserPen, label: 'Management', path: '/admin/management' },
        { icon: ClipboardList, label: 'Assignments', path: '/admin/assignments' },
        { icon: Book, label: 'Syllabus', path: '/admin/syllabus' },
        { icon: Image, label: 'Gallery', path: '/admin/gallery' },
        { icon: CalendarPlus, label: 'Upcoming Events', path: '/admin/upcoming-events' },
        { icon: Users, label: 'Faculty', path: '/admin/faculty' },
        { icon: FileText, label: 'Model Papers', path: '/admin/model-papers' },
        { icon: UserPlus, label: 'Add New User', path: '/register' },
        { icon: Briefcase, label: 'Careers', path: '/admin/careers' },
        { icon: GraduationCap, label: 'Admission', path: '/admin/admission' },
        { icon: Award, label: 'Results', path: '/admin/results' },

    ];

    return (
        <>
            <div className="row" style={{ marginTop: "8.8%" }}>
                <div className='col-2 lg-2 ' style={{ marginTop: "0px" }}>
                    <div className="w-64 bg-white-100 shadow-xl mt-4 pt-4 rounded-5 " style={{ height: "98.3%", borderRadius: "2px" }}>

                        <nav className="">
                            {navItems.map((item, index) => (
                                <Nav.Link
                                    as={Link}
                                    to={item.path}
                                    key={index}
                                    className="flex items-center px-6 py-3 text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition-colors"

                                >
                                    <item.icon className="w-5 h-5 mr-3" />
                                    <span>{item.label}</span>
                                </Nav.Link>
                            ))}
                        </nav>
                    </div >
                </div >

                <div className="col-9 mt-4 ms-5">
                    <Outlet />
                </div>
            </div >
        </>

    )
}

export default AdminLayout;